'use client';
import React from 'react';
import { Truck, ShieldCheck, FileText, Wrench } from 'lucide-react';

interface TrustBarProps {
  language: 'en' | 'ar';
}

export default function TrustBar({ language }: TrustBarProps) {
  const items = [
    {
      icon: <Truck size={28} className="text-iraqi-red" />,
      title: language === 'ar' ? 'تسليم محلي 24-48 ساعة' : '24-48hr Local Delivery',
      desc: language === 'ar' ? 'شحن سريع لكل محافظات العراق' : 'Fast shipping across all Iraqi provinces',
    },
    {
      icon: <ShieldCheck size={28} className="text-iraqi-red" />,
      title: language === 'ar' ? '100% أصلية وقابلة للتتبع' : '100% Genuine & Traceable',
      desc: language === 'ar' ? 'سلسلة توريد معتمدة بالكامل' : 'Fully certified supply chain documentation',
    },
    {
      icon: <FileText size={28} className="text-iraqi-red" />,
      title: language === 'ar' ? 'تخليص جمركي متكامل' : 'Customs Clearance Handled',
      desc: language === 'ar' ? 'نتولى كل إجراءات الاستيراد' : 'We manage all import documentation',
    },
    {
      icon: <Wrench size={28} className="text-iraqi-red" />,
      title: language === 'ar' ? 'دعم تقني ميداني' : 'On-Site Technical Support',
      desc: language === 'ar' ? 'مهندسون معتمدون في العراق' : 'Certified engineers available in Iraq',
    },
  ];

  return (
    <section className="bg-white shadow-card border-b border-slate-100" dir={language === 'ar' ? 'rtl' : 'ltr'}>
      <div className="max-w-7xl mx-auto px-4 py-6">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6">
          {items.map((item, idx) => (
            <div
              key={idx}
              className="flex items-center gap-3 group"
            >
              <div
                className="flex-shrink-0 w-12 h-12 rounded-lg flex items-center justify-center transition-colors duration-200"
                style={{ backgroundColor: 'rgba(206, 17, 38, 0.08)' }}
              >
                {item.icon}
              </div>
              <div>
                <div className="text-sm font-semibold text-onyx font-space-grotesk leading-tight">{item.title}</div>
                <div className="text-xs text-slate-grey font-roboto mt-0.5 hidden sm:block">{item.desc}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
